import type { ServerData, ServerStatsResponse } from "~/types/api/misc/serverstats/serverstats"

// Store the current abort controller
let currentAbortController: AbortController | null = null;

export const ServerStatsAPI = {
    getServerStats: async (filters?: Record<string, any>): Promise<ServerStatsResponse | { status: number, message: string }> => {
        // Cancel any pending request
        if (currentAbortController) {
            currentAbortController.abort();
        }
        
        // Create a new abort controller for this request
        currentAbortController = new AbortController();
        try {
            // Build query string from filters
            let queryString = '';
            if (filters && Object.keys(filters).length > 0) {
                // Convert all filter values to strings to ensure proper URL encoding
                const stringFilters: Record<string, string> = {};
                
                // Check if we have filters other than defaultPerfTest
                const hasOtherFilters = Object.keys(filters).some(key => key !== 'defaultPerfTest');
                
                Object.entries(filters).forEach(([key, value]) => {
                    if (value !== null && value !== undefined) {
                        // Special handling for defaultPerfTest - only include it if there are no other filters
                        if (key === 'defaultPerfTest') {
                            if (!hasOtherFilters) {
                                stringFilters[key] = value === true || value === 'Y' ? 'Y' : 'N';
                                console.log(`Setting defaultPerfTest filter: ${key}=${stringFilters[key]}`);
                            }
                        } 
                        // Special handling for filter parameters
                        else if (['buildStatus', 'perfTest_Type', 'webserver_process', 'db_server'].includes(key)) {
                            if(key != 'db_server') {
                                stringFilters[key] = String(value);
                                console.log(`Setting ${key} filter: ${key}=${String(value)}`);
                            } else {
                                stringFilters[key] = String(value.value);
                                console.log(`Setting ${key} filter: ${key}=${String(value.value)}`);
                            }
                       
                        }
                        // Special handling for date parameters
                        else if (['fromDate', 'toDate'].includes(key)) {
                            stringFilters[key] = String(value);
                            console.log(`Setting date filter: ${key}=${String(value)}`);
                        }
                        // Handle all other parameters
                        else {
                            stringFilters[key] = String(value);
                        }
                    }
                });
                
                // If no filters were added and we didn't explicitly set defaultPerfTest,
                // add defaultPerfTest=Y as the default
                if (Object.keys(stringFilters).length === 0) {
                    stringFilters.defaultPerfTest = 'Y';
                    console.log('No filters provided, using defaultPerfTest=Y as default');
                }
                
                queryString = '?' + new URLSearchParams(stringFilters).toString();
            } else {
                // If no filters provided, use defaultPerfTest=Y
                queryString = '?defaultPerfTest=Y';
            }
            
            const response = await $fetch<ServerStatsResponse>(`/api/misc/serverstats/serverstats${queryString}`, {
                headers: useRequestHeaders(),
                signal: currentAbortController.signal,
            });
            return response;
        } catch (err: any) {
            // Don't throw an error if the request was aborted
            console.log('Error:', err);
            if (err.name === 'FetchError') {
                console.log('Request was cancelled', err.statusCode, err.message);
                // throw createError({ status: err.statusCode, message: err.message  })
                // throw err; // Re-throw so caller can handle it
            }else{
                throw createError({ status: err.statusCode, message: err.data.message  })
            }
        }   
    }
};